// extracted by mini-css-extract-plugin
export var carrierTab = "_4k-0";
export var carrierTabActive = "_4k-1 _4k-0";
export var carrierTabInactive = "_4k-2 _4k-0";
export var carrierTabLabel = "_4k-3";
export var carrierTabLabelActive = "_4k-4 _4k-3";
export var carrierTabLabelInactive = "_4k-5 _4k-3";
export var carrierTabPercentage = "_4k-6";
export var carrierTabPercentageActive = "_4k-7 _4k-6";
export var carrierTabPercentageInactive = "_4k-8 _4k-6";
export var carrierTabWinnable = "_4k-9";
export var carrierTabWinnableActive = "_4k-a _4k-9";
export var carrierTabWinnableInactive = "_4k-b _4k-9";
export var comparisonContainer = "_4k-d";
export var missingRateButton = "_4k-n";
export var missingRateButtonActive = "_4k-o _4k-n";
export var missingRateButtonInactive = "_4k-p _4k-n";
export var missingRateButtonLabel = "_4k-q";
export var missingRateButtonLabelActive = "_4k-r _4k-q";
export var missingRateButtonLabelInactive = "_4k-s _4k-q";
export var sidebar = "_4k-c";
export var strategyButton = "_4k-e";
export var strategyButtonActive = "_4k-f _4k-e";
export var strategyButtonDescription = "_4k-k";
export var strategyButtonDescriptionActive = "_4k-l _4k-k";
export var strategyButtonDescriptionInactive = "_4k-m _4k-k";
export var strategyButtonInactive = "_4k-g _4k-e";
export var strategyButtonLabel = "_4k-h";
export var strategyButtonLabelActive = "_4k-i _4k-h";
export var strategyButtonLabelInactive = "_4k-j _4k-h";
export var unitToggleButton = "_4k-t";
export var unitToggleButtonActive = "_4k-u _4k-t";
export var unitToggleButtonInactive = "_4k-v _4k-t";
export var unitToggleButtonLabel = "_4k-w";
export var unitToggleButtonLabelActive = "_4k-x _4k-w";
export var unitToggleButtonLabelInactive = "_4k-y _4k-w";